import React, { useEffect, useState } from "react";
import InsightTable from "../../InsightTable";
import {
  formatBoldText,
  transformResultsToCompProfileData,
} from "../../../../../services/commonService";
import ParsedTextWithLinks from "../../../../HtmlElements/ParsedTextWithLinks";

function WarehousingChannels({ warehousingChannels = [], compView }) {
  const [tabData, setTabData] = useState([]);
  const [tableBelowDescription, setTableBelowDescription] = useState("");

  const [columns, setColumns] = useState([]);
  const [sidebarColumns, setSidebarColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  let allMetrics = [];
  useEffect(() => {
    if (compView === "quantitative") {
      allMetrics = [
        { key: "sqft", label: "Size (sq. ft.)" },
        { key: "capacity_utilization_pct", label: "Capacity Utilization (%)" },
        { key: "automation_level", label: "Automation Level" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    } else {
      allMetrics = [
        { key: "sqft", label: "Size (sq. ft.)" },
        { key: "capacity_utilization_pct", label: "Capacity Utilization (%)" },
        { key: "automation_level", label: "Automation Level" },
        { key: "strategic_role", label: "Strategic Role" },
        { key: "risks", label: "Risks" },
      ];

      setColumns(allMetrics);
      setHiddenColumns([]);
      setSidebarColumns([]);
    }
  }, [compView]);

  useEffect(() => {
    const transformed = transformResultsToCompProfileData(warehousingChannels);
    setTabData(transformed);
    // console.log("WAREHOUSING: " + JSON.stringify(transformed));
    setTableBelowDescription(
      <ParsedTextWithLinks
        text={warehousingChannels?.[0]?.response?.tableComments || ""}
      />
    );
  }, [warehousingChannels]);

  const actions = [
    // { type: "conversation", title: "Conversation", onClick: () => {} },
    // { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  if (tabData.length === 0) {
    return <></>;
  }

  return (
    <InsightTable
      title="Warehousing Channels"
      subtitle=""
      data={tabData}
      metrics={columns}
      rowIdentifier="location"
      // belowTableDescription={tableBelowDescription}
      belowTableDescription={""}
      actions={actions}
    />
  );
}

export default WarehousingChannels;
